import React, {useContext} from "react";
import {SearchContext} from "../components/SearchContext.js";

const OfferLink = ({link, heading, name, ofid}) => {
    const {doCustomSearch} = useContext(SearchContext);

    return <a href={link === null ? "#" : link} onClick={e => {
        if (!link) {
            e.preventDefault();
            doCustomSearch([{"filter":`filters[groupOffers][${ofid}][checked]`,"value":"1"}]);
        }
    }} className="offerLink" ofid={ofid}>
        <h4 className="offerHeading"><i className='fas fa-tag'></i>{heading}</h4>
        <p className='offerName'>{name}</p>
    </a>
}

export default OfferLink;